var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "question_grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question_grey",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#848F9D"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 1.5,
    cx: 10,
    cy: 10,
    r: 9.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "?",
    transform: "translate(6.5577, 4.7304)",
    fill: "#848F9D",
    fillRule: "nonzero",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.488,1.152 C2.24,1.152 1.52533333,1.64266667 1.344,2.624 L0,2.624 C0.0746666667,1.83466667 0.4,1.2 0.976,0.72 C1.552,0.24 2.36,0 3.4,0 C4.44,0 5.26133333,0.256 5.864,0.768 C6.46666667,1.28 6.768,1.904 6.768,2.64 C6.768,3.19466667 6.62933333,3.656 6.352,4.024 C6.07466667,4.392 5.62666667,4.74666667 5.008,5.088 C4.74133333,5.23733333 4.51733333,5.37066667 4.336,5.488 C4.15466667,5.60533333 4.01066667,5.73866667 3.904,5.888 C3.70133333,6.15466667 3.6,6.53866667 3.6,7.04 L3.6,7.664 L2.352,7.664 L2.352,6.944 C2.352,6.272 2.464,5.75733333 2.688,5.4 C2.912,5.04266667 3.31733333,4.704 3.904,4.384 C4.49066667,4.064 4.88533333,3.784 5.088,3.544 C5.29066667,3.304 5.392,2.98133333 5.392,2.576 C5.392,2.17066667 5.224,1.832 4.888,1.56 C4.552,1.288 4.08533333,1.152 3.488,1.152 Z M2.992,8.608 C3.26933333,8.608 3.49866667,8.69866667 3.68,8.88 C3.86133333,9.06133333 3.952,9.27733333 3.952,9.528 C3.952,9.77866667 3.86133333,9.98933333 3.68,10.16 C3.49866667,10.3306667 3.26933333,10.416 2.992,10.416 C2.71466667,10.416 2.49066667,10.3306667 2.32,10.16 C2.14933333,9.98933333 2.064,9.77866667 2.064,9.528 C2.064,9.27733333 2.14933333,9.06133333 2.32,8.88 C2.49066667,8.69866667 2.71466667,8.608 2.992,8.608 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionGrey);
export default __webpack_public_path__ + "static/media/question_grey.aaeb2cd5e96869b7853bedec784948a1.svg";
export { ForwardRef as ReactComponent };